import { render, staticRenderFns } from "./medical-page.vue?vue&type=template&id=35050d45"
import script from "./medical-page.vue?vue&type=script&lang=js"
export * from "./medical-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports